import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, catchError } from 'rxjs';

@Injectable()
export class HttpCallService {

	// tslint:disable-next-line:indent
	constructor(private http: HttpClient) { }


	/** HTTP Get call */
	public get<T>(URL: string): Observable<T> {
		return this.http.get<T>(URL).pipe(catchError(this.handleError));
	}

	public getNew<T>(URL: string): Observable<any> {
		return this.http.get<T>(URL).pipe(catchError(this.handleError));
	}

	public getfile<T>(URL: string) {
		return this.http.get(`${URL}`, { responseType: 'arraybuffer' }).pipe(catchError(this.handleError));
	}

	/**HTTP Post call */
	public post<T>(url: string, body: any): Observable<T> {
		return this.http.post<T>(url, body)
		.pipe(catchError(this.handleError));
	}

	/** HTTP Put call */
	public put<T>(url: string, body: string): Observable<T> {
		return this.http.put<T>(url, body).pipe(catchError(this.handleError));
	}

	/** HTTP Delete call */
	public delete<T>(URL: string): Observable<T> {
		return this.http.delete<T>(URL).pipe(catchError(this.handleError));
	}
	/** HTTP Delete call */
	public deleteByBody<T>(URL: string, data: any): Observable<T> {
		return	this.http.request<T>('delete', URL, { body: data }).pipe(catchError(this.handleError));
	}

	/** HTTP Patch call */
	public patch<T>(url: string, body: string): Observable<T> {
		return this.http.patch<T>(url, body).pipe(catchError(this.handleError));
	}

	public handleError(error: HttpErrorResponse) {
		return throwError(error);
	}


}
